/* eslint-disable */
export const messages = {
  resetPassword: {
    title: {
      id: 'authrepAcctSetConfirm.ResetPassword.Title',
      defaultMessage: 'Reset Password?',
    },
    instruction: {
      id: 'authrepAcctSetConfirm.ResetPassword.Instruction',
      defaultMessage: 'Resetting the password for this account will email a temporary password to {userEmailAddress}.',
    },
    button: {
      submit: {
        id: 'authrepAcctSetConfirm.ResetPassword.Button.Submit',
        defaultMessage: 'Yes, reset the password',
      },
      cancel: {
        id: 'authrepAcctSetConfirm.ResetPassword.Button.Cancel',
        defaultMessage: 'No, take me back',
      },
    },
  },
  enableAccess: {
    title: {
      id: 'authrepAcctSetConfirm.EnableAccess.Title',
      defaultMessage: 'Enable Access?',
    },
    instruction: {
      id: 'authrepAcctSetConfirm.EnableAccess.Instruction',
      defaultMessage: 'Enabling access will allow this contact to log in to their account and view your health information.',
    },
    button: {
      submit: {
        id: 'authrepAcctSetConfirm.EnableAccess.Button.Submit',
        defaultMessage: 'Yes, enable access',
      },
      cancel: {
        id: 'authrepAcctSetConfirm.EnableAccess.Button.Cancel',
        defaultMessage: 'No, take me back',
      },
    },
  },
  disableAccess: {
    title: {
      id: 'authrepAcctSetConfirm.DisableAccess.Title',
      defaultMessage: 'Disable Access?',
    },
    instruction: {
      id: 'authrepAcctSetConfirm.DisableAccess.Instruction',
      defaultMessage: 'Disabling access will prevent this contact from logging in to their account. No information will be deleted and the account can be re-enabled later if needed.',
    },
    button: {
      submit: {
        id: 'authrepAcctSetConfirm.DisableAccess.Button.Submit',
        defaultMessage: 'Yes, disable access',
      },
      cancel: {
        id: 'authrepAcctSetConfirm.DisableAccess.Button.Cancel',
        defaultMessage: 'No, take me back',
      },
    },
  },
  resendInvite: {
    title: {
      id: 'authrepAcctSetConfirm.ResendInvite.Title',
      defaultMessage: 'Resend Invitation?',
    },
    instruction: {
      id: 'authrepAcctSetConfirm.ResendInvite.Instruction',
      defaultMessage: 'A new invitation will be emailed to {contactEmail}, and a new PIN will be created that you will need to provide to this contact.',
    },
    button: {
      submit: {
        id: 'authrepAcctSetConfirm.ResendInvite.Button.Submit',
        defaultMessage: 'Yes, resend the invitation',
      },
      cancel: {
        id: 'authrepAcctSetConfirm.ResendInvite.Button.Cancel',
        defaultMessage: 'No, take me back',
      },
    },
  },
  contactIsDirty: {
    title: {
      id: 'authrepAcctSetConfirm.ContactIsDirty.Title',
      defaultMessage: 'Save Changes?',
    },
    instruction: {
      id: 'authrepAcctSetConfirm.ContactIsDirty.Instruction',
      defaultMessage: 'Would you like to save your changes before continuing?',
    },
    button: {
      submit: {
        id: 'authrepAcctSetConfirm.ContactIsDirty.Button.Submit',
        defaultMessage: 'Yes, save changes',
      },
      cancel: {
        id: 'authrepAcctSetConfirm.ContactIsDirty.Button.Cancel',
        defaultMessage: 'No, don\'t save',
      },
    },
  },
};
